class Locale {
    constructor (tag, { name, region }) {
        this.tag = tag;
        this.name = name;
        this.region = region;
    }
}

export default Locale;